import { useCachedQuery } from '../../hooks/useCachedQuery';

// Dados de uma consulta, com cache de leitura offline (via useCachedQuery).
export function useAppointment(appointmentId) {
  const url = appointmentId ? '/appointments/'.concat(appointmentId) : null;

  const { data, isLoading, isStale, updatedAt, error, refetch } = useCachedQuery(url);

  return {
    appointment: data ?? null,
    isLoading,
    isStale,
    updatedAt,
    error,
    refetch,
  };
}
